export class RequestIntermediarioEnlace {
  public cod_agente: number;
  public incod_tipo_agente: number;
  public inestado: number;
  public cod_usuarioSISE: string;

  constructor(
    cod_agente: number,
    incod_tipo_agente: number,
    inestado: number,
    cod_usuarioSISE: string
  ) {
    this.cod_agente = cod_agente;
    this.incod_tipo_agente = incod_tipo_agente;
    this.inestado = inestado;
    this.cod_usuarioSISE = cod_usuarioSISE;
  }
}
